import { Badge, Box, Container, Stack } from '@chakra-ui/react'
import React from 'react'
import { useSelector } from 'react-redux'

import { useTranslations } from '~shared-components/hooks/useTranslations'
import { IconCart } from '~shared-components/icons/brand/IconCart'

import { CartSelector } from '../../redux/selectors/cart.selector'
import { Pill } from '../Pill/Pill'
import { RouterLink, RouterLinkProps } from '../RouterLink/RouterLink'

interface Props {
  cartLink: RouterLinkProps['to']
}

const Cart = ({ cartLink }: Props) => {
  const currency = useSelector(CartSelector.currency)
  const isCartPopulated = useSelector(CartSelector.isPopulated)
  const cartProducts = useSelector(CartSelector.products)
  const cartCount = isCartPopulated ? cartProducts.length : undefined
  const t = useTranslations()

  return (
    <Container color="white.0" padding="0" position="relative">
      <RouterLink aria-label={t('label.shoppingcart')} to={cartLink}>
        <IconCart boxSize="20px" color="neutral.70" />
        <Container
          display="flex"
          fontSize="10px"
          position="absolute"
          top="-15px"
        >
          <Stack direction={['column', 'column', 'row']} spacing={1}>
            {Boolean(cartCount) && (
              <Pill data-testid="cart-count" size="md" variant="chip-solid">
                {cartCount}
              </Pill>
            )}
            <Box>
              {currency && (
                <Badge
                  bg="deepPurple"
                  color="white.0"
                  fontSize="1em"
                  lineHeight="1"
                  ml={['-22px', '-22px', '1px']}
                  mt={['6px', '6px', 'initial']}
                  p="5px"
                >
                  {currency}
                </Badge>
              )}
            </Box>
          </Stack>
        </Container>
      </RouterLink>
    </Container>
  )
}

export default Cart
